var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCurveMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 302,
    viewBox: "0 0 390 302",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-265.325 81.7117C-251.89 118.717 -227.707 209.557 -229.97 245.76C-232.798 291.015 -195.635 -9.11199 -81.4772 -18.6976C11.1538 -26.4757 34.0167 193.906 34.4884 299.5C70.3146 200.035 228.032 44.2482 400 110.999",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCurveMobile);
export default __webpack_public_path__ + "static/media/white-curve-mobile.f465aaf18778e62ae3c1481062e40855.svg";
export { ForwardRef as ReactComponent };